module.exports = __webpack_public_path__ + "d7a00ee4590a955d6021c40a4f156973.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Dollarstats.png
// module id = 1429
// module chunks = 0